import { render, staticRenderFns } from "./PowerMainTable.vue?vue&type=template&id=02841de5&scoped=true"
import script from "./PowerMainTable.vue?vue&type=script&lang=js"
export * from "./PowerMainTable.vue?vue&type=script&lang=js"
import style0 from "./PowerMainTable.vue?vue&type=style&index=0&id=02841de5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02841de5",
  null
  
)

export default component.exports